<template>
  <div class="basic_wrap">
    <div class="login_bg">
      <div
        class="back_left"
        @click="$router.back()"
      />
      <div
        class="auth_brand"
        aria-hidden="true"
      >
        <span />
        <span />
      </div>
      <div
        class="language"
        @click="$router.push('/language')"
      >
        <img :src="require('../images/shop2/lang.png')">
      </div>
    </div>
    <div class="login_logo">
      <img
        class="logo"
        src="../images/shop2/top.jpg"
      >
    </div>
    <div class="form">
      <h1 class="auth_title">
        {{ $t('register.register') }}
      </h1>
      <!-- 	<div class="cut_login">
				<router-link to="/login">
					{{$t('register.signIn')}}
					<div class="line" />
				</router-link>
				<router-link class="cur" to="/register">
					{{$t('register.signUp')}}
					<div class="line" />
				</router-link>
			</div> -->
      <!-- 		<div class="item">
				<span class="icon">
					<van-icon name="envelop-o" size="25"/>
				</span>
				<input v-model.trim="data.mobile" type="text" class="inp" :placeholder="$t('register.phoneNumber')">
			</div> -->
      <div class="item">
        <span class="icon">
          <van-icon
            name="user-o"
            size="25"
          />
        </span>
        <input
          v-model.trim="data.unanme"
          type="text"
          class="inp"
          :placeholder="$t('register.inunanme')"
          @input="chageuname"
        >
      </div>
      <!-- 	<div class="item">
				<span class="icon">
					<van-icon name="user-o" size="25"/>
				</span>
				<van-radio-group v-model="sex" direction="horizontal">
				  <van-radio checked-color="#fc494d" name="1">{{$t('d.male')}}</van-radio>
				  <van-radio checked-color="#fc494d" name="2">{{$t('d.female')}}</van-radio>
				</van-radio-group>
			</div> -->
      <!-- <div class="item">
				<span class="icon">
					<van-icon name="phone-o" size="25"/>
				</span>
				<input v-model.trim="data.mobile" type="number" class="inp" :placeholder="$t('register.phoneNumber')">
			</div> -->
      <!-- <div class="item">
				<span class="icon">
					<img src="../images/login/p1.png" alt="">
				</span>
				<input type="text" class="inp" v-model.trim="data.name" placeholder="请输入用户名" />
			</div> -->
      <div class="item">
        <span class="icon">
          <van-icon
            name="lock"
            size="25"
          />
        </span>
        <input
          v-model.trim="data.password"
          :type="password"
          class="inp"
          :placeholder="$t('register.password')"
        >
        <div
          class="eye_bi"
          :class="password == 'text' ? 'eye' : ''"
          @click="showPwd"
        />
      </div>
      <div class="item">
        <span class="icon">
          <van-icon
            name="lock"
            size="25"
          />
        </span>
        <input
          v-model.trim="data.spassword"
          :type="password"
          class="inp"
          :placeholder="$t('register.spassword')"
        >
        <div
          class="eye_bi"
          :class="password == 'text' ? 'eye' : ''"
          @click="showPwd"
        />
      </div>
      <!-- <div class="item">
                <input type="text" class="inp" v-model.trim="data.code" :placeholder="$t('forgetpwe.code')"/>
                <van-count-down :time="time" format='mm:ss' class="btn get_captcha" @finish="timeCall">
                    <template v-slot="timeData">
                        <span @click="sendcode">{{timeData.seconds > 0 ? (timeData.minutes+':'+timeData.seconds): $t('forgetpwe.send')}}</span>
                    </template>
                </van-count-down>
            </div> -->
      <!-- <div class="item">
				<input type="password" class="inp" v-model.trim="data.paypwd" placeholder="请输入支付密码" />
			</div>
			<div class="item">
				<input type="password" class="inp" v-model.trim="data.confirm_paypwd" placeholder="请再次输入支付密码" />
			</div> -->
      <!-- <div v-if="show_sms > 0" class="item">
				<input v-model.trim="data.code" type="text" class="inp" :placeholder="$t('register.code')">
				<van-count-down :time="time" format='mm:ss'  class="btn get_captcha" @finish="timeCall">
					<template v-slot="timeData">
						<span @click="sendcode">{{
						  timeData.seconds > 0
							? timeData.seconds
							: $t('register.sendCode')
						}}</span>
					</template>
				</van-count-down>
			</div> -->
      <template>
        <div class="item">
          <span class="icon">
            <van-icon
              name="friends-o"
              size="25"
            />
          </span>
          <input
            v-model.trim="data.t_mobile"
            type="text"
            class="inp"
            :placeholder="$t('register.referralCode')"
          >
        </div>
      </template>
      <div class="item_reset_pwd">
        <van-checkbox-group
          v-model="checked"
          shape="square"
        >
          <van-checkbox
            name="a"
            checked-color="#fc494d"
            style="height: 35px;"
          >
            {{ $t('d.least18') }}
          </van-checkbox>
          <van-checkbox
            name="b"
            checked-color="#fc494d"
            style="height: 35px;"
          >
            {{ $t('d.acceptc') }}
            <a
              href="/#/about/35"
              class=""
              style="margin-left: 4px;"
            >
              {{ $t('d.terms') }}
            </a>
          </van-checkbox>
        </van-checkbox-group>
      </div>
			
      <div
        class="basic_btn sbtn"
        :class="
          data.unanme == '' ||
            data.password == '' ||
            data.spassword != data.password
            ? 'no_touch'
            : ''
        "
        @click="submit"
      >
        {{ $t('register.register') }}
      </div>
      <div class="register">
        {{ $t('register.signIn') }}<router-link
          class="link"
          to="/login"
        >
          {{ $t('register.signUp') }}
        </router-link>
      </div>
    </div>
		
    <van-dialog
      v-model="statement"
      confirm-button-color="#fb661e"
      :close-on-click-overlay="true"
      @click="privacyStatementHide"
    />
    <van-dialog
      v-model="agreement"
      confirm-button-color="#fb661e"
      :close-on-click-overlay="true"
      @click="agreementHider"
    />
    <div
      v-if="msg_show"
      class="kefu"
      :class="show_kefu ? '' : 'kefu_hide'"
      @click="kefu_to"
    >
      <img
        class="kefu_img"
        src="../images/shop2/kefu.jpg"
      >
    </div>
  </div>
</template>

<script>
	import Vue from "vue";
	import {
		Icon,
		CountDown,
		RadioGroup, 
		Radio,
		Checkbox, 
		CheckboxGroup,
		Dialog
	} from "vant";
	import Fetch from "../../utils/fetch";

	Vue.use(CountDown)
		.use(Icon)
		.use(RadioGroup)
		.use(Radio)
		.use(Checkbox)
		.use(CheckboxGroup)
		.use(Dialog);

	export default {
		name: "Register",
		data() {
			return {
				time: 0,
				agreement: false,
				lang:this.$i18n.locale||"en_us",
				statement: false,
				show_kefu: false,
				msg_show: true,
				sex:"1",
				show_sms: 0,
				// checked:['a', 'b'],
				checked:[],
				password: "password",
				data: {
					password: "",
					spassword: "",
					paypwd: "",
					mobile: "",
					t_mobile: "",
					telacc: "",
					unanme: "",
					code: "",
					agent: 10000
				},
				config: {}
			};
		},
		created() {
			this.$parent.footer("user", false);
			this.getparams();
			// 安卓返回IMEI，苹果返回UID值
			/*BSL.PhoneID('callName');
			window.callName = this.methodName;
			// 获取手机OAID
			BSL.GetOAID('getExternalInfo');
			window.getExternalInfo = this.getExternalInfoData; */
		},
		mounted() {
			if (this.$route.query.agent) {
				localStorage.setItem('agent', this.$route.query.agent);
				this.data.agent = this.$route.query.agent;
			} else {
				if (localStorage.getItem('agent')) {
					this.data.agent = localStorage.getItem('agent');
				}
			}
			var that = this;
			document.body.addEventListener(
				"scroll",
				function() {
					if (!that.show_kefu) {
						return;
					}
					that.show_kefu = false;
				},
				false
			);
			document.addEventListener(
				"click",
				function(ev) {
					if (ev.target.className != "kefu_img") {
						that.show_kefu = false;
					}
				},
				false
			);
			Fetch('/index/webconfig', {
				type: 'web'
			}).then(res => {
				this.config = res.data
				this.show_sms = res.data.sms_verify
			})
		},
		methods: {
			chageuname(){
				var input = this.data.unanme;
				var stringWithoutLeadingDigit = input.replace(/^\d+/, '');
				  // 去掉字符串中的空格
				this.data.unanme = stringWithoutLeadingDigit.replace(/\s+/g, '');
			},
			kefu_to() {
				if (this.show_kefu) {
					this.$router.push("/kefu2");
				}
				this.show_kefu = !this.show_kefu;
			},
			showPwd() {
				if (this.password == "password") {
					this.password = "text";
				} else {
					this.password = "password";
				}
			},
			methodName(r) {
				this.data.imei = r;
			},
			getExternalInfoData(info) {
				var info = JSON.parse(info);
				console.log(info);
				if (info.code == 0) {
					this.data.oaid = info.oaid;
				}
			},
			getparams() {
				var m = this.$route.query.m;
				if(m && parseInt(m)>0){
					localStorage.setItem('t_mobile', m);
					this.data.t_mobile = m;
				}else{
					if (localStorage.getItem('t_mobile')) {
						this.data.t_mobile = localStorage.getItem('t_mobile');
					}
				}
			},
			timeCall() {
				this.is_send = false;
				this.time = 0;
			},
			sendcode() {
				if (this.is_send) {
					return;
				}

				if (!this.data.mobile) {
					this.$toast(this.$t('register.phoneEmpty'));
					return;
				}

				this.is_send = true;

				Fetch("/index/register_code", {
						mobile: this.data.mobile,
					})
					.then(() => {
						this.time = 120 * 1000;
						this.$toast({
							background: "#07c160",
							message: this.$t('register.sendSuccess'),
						});
					})
					.catch(() => {
						this.is_send = false;
					});
			},
			submit() {
				// if (!this.data.mobile) {
				// 	this.$toast(this.$t('register.phoneEmpty'));
				// 	return false;
				// }
				if (!this.data.password) {
					this.$toast(this.$t('register.passwordEmpty'));
					return false;
				}
				if (!this.data.t_mobile || this.data.t_mobile.length<3) {
					this.$toast(this.$t('d.codeno'));
					return false;
				}
				// if (!this.data.spassword) {
				//     this.$toast(this.$t('register.passwordAgainEmpty'));
				//     return false;
				// }

				if (!this.data.code && this.config.sms_verify) {
					this.$toast(this.$t('register.codeEmpty'));
					return false;
				}
				if (this.data.password != this.data.spassword) {
				    this.$toast(this.$t('register.passwordError'));
				    return false;
				}
				this.data.mobile = this.data.unanme;
				if(this.checked.length!=2){
					this.$toast("Please read and agree to the terms of service");
					return false;
				}
				Fetch("/index/register", {
					password: this.data.password,
					spassword: this.data.spassword,
					paypwd: this.data.paypwd,
					mobile: this.data.mobile,
					t_mobile: this.data.t_mobile,
					telacc: this.data.telacc,
					unanme: this.data.unanme,
					code: this.data.code,
					agent: this.data.agent
				}).then((res) => {
					if (res.data.token) {
						localStorage.setItem('token', res.data.token);
					}
					this.$toast(this.$t('register.signUpSuccess'));
					this.$router.replace("/");
				});
			},
			userAgreement() {
				this.agreement = true;
			},
			agreementHider() {
				this.agreement = false;
			},
			privacyStatement() {
				this.statement = true;
			},
			privacyStatementHide() {
				this.statement = false;
			},
			changeLang(lang,event) {
				Toast.loading({
					// mask: true,
					duration: 200
				})
				this.lang = lang;
				this.$i18n.locale = lang;
				localStorage.setItem("lang", lang);
				this.$router.go(-1);
			}
		},
	};
</script>

<style lang="less" scoped>
	.login_bg {
		width: 100%;
		height: 48px;
		overflow: hidden;
		position: relative;
		.language{
			position: absolute;
			top: 4px;
			right: 0;
			height: 36px;
			img{
				display: block;
				height: 100%;
			}
		}
	}

	.basic_wrap .form {
		box-sizing: border-box;
		margin: 0 auto 32px;
		width: 94%;
		background: rgba(255, 255, 255, 1);
		box-shadow: 0 4px 9px 2px rgba(160, 160, 160, 0.15);
		border-radius: 13px;
		padding: 12px 8% 30px;
	}

	.cut_login {
		width: 207px;
		line-height: 25px;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 18px;
		text-align: center;
		margin: 0 auto;

		a {
			width: 50%;
			padding-bottom: 10px;
			color: #808080;
			position: relative;

			.line {
				width: 100%;
				height: 1px;
				position: absolute;
				left: 0;
				bottom: 0;
				background-color: #f2f2f2;
			}
		}

		a.cur {
			color: #D20100cc;

			.line {
				height: 2px;
				background-image: linear-gradient(to right, #f90, #f18a11);
			}
		}
	}
	.big_tit{
		color: #000;
	}
	.block {
		width: 100%;
		height: 100%;
		// overflow:hidden;
		// margin: 10% auto;
		font-size: 15px;
		justify-content: center;
		background-color: #fff;
		border-radius: 5px;

		.block-title {
			display: block;
			font-weight: bolder;
			line-height: 39px;
			height: 39px;
			text-align: center;
		}

		.p_agr {
			// padding-top:30rpx;
			font-size: 12px;
			/*font-weight: bolder;*/
			line-height: 20px;
			padding: 0px 10px;
			height: 388px;
			/*overflow: hidden;*/
			// overflow: auto;
			-webkit-overflow-scrolling: touch;
			overflow-y: scroll;
		}

		.div_qd {
			width: 60px;
			height: 25px;

			span {
				width: 60px;
				height: 20px;
				line-height: 20px;
				text-align: center;
				justify-content: center;
				background: #fb661e;
				border-radius: 10px;
				padding: 1px 5px;
				color: #fff;
			}

			margin: 10px auto;
		}
	}

	.item {
		height: 64px;
		border-bottom: 1px solid #f0f1f3;
		font-size: 14px;
		display: flex;
		justify-content: flex-start;
		align-items: flex-end;
		padding-bottom: 4px;

		.icon {
			display: flex;
			justify-content: center;
			align-items: center;
			width: 28px;
			height: 24px;

			.people {
				width: 23px;
				height: 20px;
			}

			img {
				height: 100%;
			}
		}

		input {
			height: 20px;
			margin-left: 7px;
			flex: 1;
			min-width: 0;
			margin-bottom: 3px;
			border: 0;
			outline: 0;
			color: #000;
			background: transparent;
		}
	}

	.item input::placeholder {
		color: #000;
		font-weight: 700;
	}

	.item_reset_pwd {
		margin-top: 16px;
		color: #000;
		font-size: 13px;
		line-height: 20px;
	}

	.item_reset_pwd a {
		color: #5727a3;
	}

	/deep/ .van-checkbox__label {
		color: #000;
		font-size: 13px;
		line-height: 20px;
	}

	/deep/ .van-checkbox__icon--checked .van-icon {
		border-color: #f32d5b;
		background-color: #f32d5b;
	}

	.get_captcha {
		width: 88px;
		height: 34px;
		background: linear-gradient(90deg,
				rgba(228, 57, 46, 1) 0%,
				rgba(254, 76, 22, 1) 100%);
		border-radius: 4px;
		text-align: center;
		line-height: 34px;
		font-size: 14px;
		color: #ffffff;
	}

	.protocol {
		font-size: 12px;
		line-height: 17px;
		margin-top: 20px;
		color: #999999;

		a {
			color: #3d96ff;
		}
	}

	.basic_btn {
		height: 45px;
		margin: 28px auto 0;
		border: 0;
		border-radius: 5px;
		color: #fff;
		font-size: 16px;
		line-height: 45px;
		background: linear-gradient(90deg, #ff2d5b, #c71964);
		box-shadow: 0 9px 14px rgba(176, 32, 90, 0.25);
	}
	/deep/ .van-icon {
	}
	.login_logo {
	    width: 100%;
	    color: #fff;
	    text-align: center;
	    -webkit-animation: bot_top-data .3s;
	    animation: bot_top-data .3s;
	}
	.login_logo img {
	    width: 100%;
		-webkit-animation: logobig-data .5s;
		animation: logobig-data .5s;
		margin-bottom: 10px;
		border-radius: 10px;
	}
	.form{
		-webkit-animation: bot_top-data .3s;
		animation: bot_top-data .3s;
	}
	@-webkit-keyframes bot_top-data {
	    0% {
	        margin-top: 1000px;
	        opacity: 0;
	    }
	    100% {
	        margin-top: 0;
	        opacity: 1;
	    }
	}
	
	@keyframes bot_top-data {
	    0% {
	        margin-top: 1000px;
	        opacity: 0;
	    }
	    100% {
	        margin-top: 0;
	        opacity: 1;
	    }
	}
	@-webkit-keyframes logobig-data{
		0% {
		    -webkit-transform: scale(.3);
		    opacity: 0;
		}
		50% {
		    -webkit-transform: scale(1.2);
		    opacity: .5;
		}
		100% {
		    -webkit-transform: scale(1);
		    opacity: 1;
		}
	}
	@keyframes logobig-data{
		0% {
		    -webkit-transform: scale(.3);
		    opacity: 0;
		}
		50% {
		    -webkit-transform: scale(1.2);
		    opacity: .5;
		}
		100% {
		    -webkit-transform: scale(1);
		    opacity: 1;
		}
	}
	.register{
		line-height: 20px;
		text-align: center;
		margin-top: 26px;
		color: #000;
		font-size: 12px;
		.link{
			margin-left: 5px;
			color: #5727a3;
		}
	}
	
	.basic_wrap {
		max-width: 750px;
		background: #fff url(../images/shop2/1.png) no-repeat center top;
		padding-bottom: 10%;
		background-size: cover;
		display: inline-block;
		width: 100%;
		min-height: 100vh;
	}
	.area_code{
		font-size: 16px;
		line-height: 20px;
		padding: 5px;
	}

	/* Airbnb-inspired authentication visual system */
	.basic_wrap {
		position: relative;
		flex: 0 0 auto;
		min-height: 100vh;
		overflow: visible;
		background: #f7f7f7;
	}

	.basic_wrap::before {
		position: absolute;
		inset: 0;
		content: '';
		background:
			linear-gradient(180deg, rgba(255, 255, 255, 0.94) 0%, rgba(255, 255, 255, 0.78) 100%),
			url('../images/shop2/1.png') no-repeat center / cover;
		pointer-events: none;
	}

	.login_bg,
	.form {
		position: relative;
		z-index: 1;
	}

	.login_bg {
		display: flex;
		align-items: center;
		justify-content: center;
		height: 50px;
		overflow: visible;
		background: rgba(255, 255, 255, 0.92);
		border-bottom: 1px solid rgba(34, 34, 34, 0.08);
	}

	.login_bg .back_left {
		position: absolute;
		top: 14px;
		left: 10px;
		width: 22px;
		height: 22px;
		margin: 0;
	}

	.auth_brand {
		position: relative;
		width: 34px;
		height: 34px;
	}

	.auth_brand span {
		position: absolute;
		top: 4px;
		width: 17px;
		height: 27px;
		border: 3px solid #ff385c;
		border-radius: 15px 15px 14px 14px;
		transform: rotate(-33deg);
	}

	.auth_brand span:first-child {
		left: 6px;
	}

	.auth_brand span:last-child {
		right: 6px;
		transform: rotate(33deg);
	}

	.login_bg .language {
		top: 7px;
		right: 18px;
		width: 36px;
		height: 36px;
	}

	.login_bg .language img {
		width: 100%;
		height: 100%;
	}

	.login_logo {
		display: none;
	}

	.basic_wrap .form {
		box-sizing: border-box;
		width: calc(100% - 20px);
		margin: 38px auto 32px;
		padding: 30px 22px 28px;
		border: 1px solid rgba(34, 34, 34, 0.08);
		border-radius: 24px;
		background: rgba(255, 255, 255, 0.96);
		box-shadow: 0 12px 32px rgba(0, 0, 0, 0.1);
		-webkit-animation: none;
		animation: none;
	}

	.auth_title {
		margin: 0 0 24px;
		color: #222;
		font-size: 20px;
		font-weight: 700;
		line-height: 32px;
		text-align: center;
	}

	.item {
		box-sizing: border-box;
		align-items: center;
		height: 58px;
		margin-top: 12px;
		padding: 0 14px;
		border: 1px solid #b0b0b0;
		border-radius: 12px;
		background: #fff;
	}

	.item:first-of-type {
		margin-top: 0;
	}

	.item .icon {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 28px;
		height: 100%;
		color: #222;
	}

	.item input {
		height: 100%;
		margin: 0 0 0 10px;
		color: #222;
		font-size: 15px;
		font-weight: 400;
	}

	.item input::placeholder {
		color: #717171;
		font-weight: 400;
	}

	.eye_bi {
		width: 20px;
		height: 24px;
	}

	.item_reset_pwd {
		margin-top: 18px;
		color: #222;
		font-size: 14px;
		line-height: 20px;
	}

	.item_reset_pwd a {
		color: #222;
		font-weight: 500;
		text-decoration: underline;
	}

	/deep/ .van-checkbox__label {
		color: #222;
		font-size: 14px;
		line-height: 20px;
	}

	/deep/ .van-checkbox__icon--checked .van-icon {
		border-color: #ff385c;
		background-color: #ff385c;
	}

	.form .basic_btn {
		width: 100%;
		height: 50px;
		margin: 28px 0 0;
		border-radius: 12px;
		color: #fff;
		font-size: 16px;
		font-weight: 600;
		line-height: 50px;
		background: #ff385c;
		box-shadow: none;
	}

	.form .basic_btn.no_touch {
		color: #fff;
		opacity: 0.5;
	}

	.register {
		margin-top: 24px;
		color: #222;
		font-size: 14px;
		line-height: 20px;
	}

	.register .link {
		color: #222;
		font-weight: 600;
		text-decoration: underline;
	}

	.kefu {
		width: 50px;
		height: 50px;
	}

	.login_logo {
		position: relative;
		z-index: 1;
		display: block;
		width: calc(100% - 20px);
		margin: 6px auto 0;
		overflow: hidden;
		border: 1px solid rgba(255, 255, 255, 0.9);
		border-radius: 20px;
		background: #fff;
		box-shadow: 0 14px 30px rgba(0, 0, 0, 0.12);
		-webkit-animation: bot_top-data 0.3s;
		animation: bot_top-data 0.3s;
	}

	.login_logo img {
		display: block;
		width: 100%;
		margin: 0;
		border-radius: 0;
		-webkit-animation: logobig-data 0.5s;
		animation: logobig-data 0.5s;
	}

	.basic_wrap .form {
		margin-top: 18px;
	}
</style>
